import { BaseService } from '../base/BaseService';
export class AiClassificationService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiClassificationService.DEFAULT_SERVICE_PATH,
            basePath: AiClassificationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async classifyRaw(request) {
        return this.http.post(this.buildUrl('classify'), request);
    }
    async classify(request) {
        const response = await this.classifyRaw(request);
        if (!response.data)
            throw new Error('No data returned from classification');
        return response.data;
    }
    async suggestTagsRaw(request) {
        return this.http.post(this.buildUrl('suggest-tags'), request);
    }
    async suggestTags(request) {
        const response = await this.suggestTagsRaw(request);
        if (!response.data)
            throw new Error('No data returned from tag suggestion');
        return response.data;
    }
}
AiClassificationService.DEFAULT_SERVICE_PATH = 'ai-management';
AiClassificationService.BASE_PATH = 'api/ai/classification';
//# sourceMappingURL=AiClassificationService.js.map